import { SchemaCustomfield } from '@/__generated/es-api'
import { ContactValues } from '@/app/module/contacts/types'
import { ContactPermissions } from '@/app/types'

export const filterRestrictedFieldValues = <Values extends ContactValues>(
  contactPerm: ContactPermissions,
  customFields: SchemaCustomfield[],
  values: Values,
) => {
  const filteredValues = { ...values }

  // filter standard fields based on permissions
  Object.keys(contactPerm).forEach((key) => {
    if (!contactPerm[key as keyof ContactPermissions]) {
      delete filteredValues[key as keyof Values]
    }
  })

  // filter custom fields based on permissions
  customFields.forEach((field) => {
    if (!field.access) {
      delete filteredValues[`customFields${field.id}`]
    }
  })

  // delete non-editable fields
  delete filteredValues.carrier
  delete filteredValues.createdAt
  delete filteredValues.lastUseAt
  delete filteredValues.updatedAt

  return filteredValues
}
